module.exports = __webpack_public_path__ + "img/Instagram.84bf6b39.png";